// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewSwitch_wrapper__2sPEx","buttons":"ViewSwitch_buttons__2VEiT"};